import { render, staticRenderFns } from "./loyaltyMoments.vue?vue&type=template&id=2ddbf0e3&"
import script from "./loyaltyMoments.vue?vue&type=script&lang=js&"
export * from "./loyaltyMoments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports